import ConditionalWrapper from '@/components/conditional_wrapper.js' 
import {useRouter} from 'next/router'; 
import Link from 'next/link'; 
export default function DownloadTabs({currentTab, setCurrentTab}) {
  let tab = currentTab || 'product-assets'  
  let router = useRouter()
  const changeTab = (tab) => {
    setCurrentTab(tab);
    window.history.pushState('', '', router.asPath.replace(/\/.*$/, '')  + tab)
  }
  return (
    <section className="lexcms-downloads-page-tabs">
      <ConditionalWrapper
         condition={tab !== 'product-assets'}
         wrapper={(children) =>{ return (<a 
           onClick={() => changeTab('product-assets')}>{children}</a>) } }>
           <p className="lexcms-downloads-page-tab">Product Assets</p>
      </ConditionalWrapper>
       <ConditionalWrapper
         condition={ tab !== 'company-resources'}
         wrapper={(children) =>{  return (<a 
           onClick={() => changeTab('company-resources')}>{children}</a>) } }>
        <p className="lexcms-resources-page-tab">Company Resources</p>
      </ConditionalWrapper>
    </section>
  )
 }


